<template>
  <div class="w-footer-line">
    <slot></slot>
  </div>
</template>

<script>
  export default {

  }
</script>

<style lang="scss" scoped>
  .w-footer-line {
    // width: 1200px;
    margin: 0 auto;
    display: flex;
    flex-direction: row;
    justify-content: center;
    margin-top: 10px;
    margin-bottom: 10px;
    font-size: 14px;

    span {
      font-size: 14px;
    }

    a {
      color: #909399;
      font-size: 14px;
      text-decoration: none;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/login/config/w-footer-line.vue